import React, { useEffect } from "react"
import MetaTags from 'react-meta-tags';
import { connect } from "react-redux";
import Miniwidget from "./Miniwidget";
import { Card, CardBody, Row , Col} from "reactstrap"
import AreaChart from "./areachart";
import AreachartHour from "./areachartHour";
import Barchart from "./barchart";
import Campuslist from "./Campuslist";
import YearlySales from "./yearly-sales";
import Speedometer from "./Speedometer";
import ViolationTables from "./ViolationTableComponent";
import {
  CardImg,
  Button,
  CardText,
  CardHeader,
  CardImgOverlay,
  CardFooter,
  CardDeck,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  ButtonDropdown,
  
} from "reactstrap"
import {useState } from "react"
//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import Heatmapcontainer from "./Heatmapcontainer";
import {CampusIdContext} from "components/Common/PageDataContext";

const Dashboard = (props) => {

  const [ selectedCampusval, setCampusValue ] = useState()
  const breadcrumbItems = [

  ]
    useEffect(() => {
      props.setBreadcrumbItems('Dashboard', breadcrumbItems);
     
  })
  const Contextvalue = {  selectedCampusval, setCampusValue };


return (
    <React.Fragment>
      <MetaTags>
        <title>Indus | Dashboard</title>
      </MetaTags>
      <CampusIdContext.Provider value={Contextvalue}>
<Campuslist  setCampusValue={setCampusValue}></Campuslist>
                  </CampusIdContext.Provider>
                  
                  <Row className="" style={{marginTop:'3%',}}>
                  <Col lg={3} xl={3}  style={{display : 'inline-block'}}>
      
                  <Speedometer CampusID={selectedCampusval} type={"dailyMax"}></Speedometer>

</Col>
<Col lg={3} style={{display : 'inline-block'}}>
 <Miniwidget CampusID={selectedCampusval} type={"daily"}/>
 </Col> 
 <Col lg={3} style={{display : 'inline-block'}}>  
 <Speedometer CampusID={selectedCampusval} type={"monthlyMax"}></Speedometer>
 </Col>
 <Col lg={3} style={{display : 'inline-block'}}>  
 <Miniwidget CampusID={selectedCampusval} type={"monthly"}/>
 </Col> 
 </Row>

 <Row>
                <Col lg="6">
                  
                                <Barchart CampusID={selectedCampusval}></Barchart>

                </Col>
                <Col lg="6">
           
        <AreaChart CampusID={selectedCampusval}></AreaChart>
  
                </Col>
            </Row>
{/*      
          <Row>
            <Col lg={7}>


                                 <AreachartHour CampusID={selectedCampusval}></AreachartHour>
            </Col>
            <Col xl="5" style={{display:'inline-block'}}>
        

       
          <YearlySales CampusID={selectedCampusval}></YearlySales>
        
          <Speedometer CampusID={selectedCampusval} type={"dailyAvg"}></Speedometer>
        </Col>
          </Row> */}
          <Row>
<Col lg="7">
<Card>
                        <CardBody>

                            <h4 className="card-title mb-4">Latest Violations</h4>

                          

                            <div dir="ltr">
                                {/* <LineApexChart /> */}
                                <ViolationTables CampusID={selectedCampusval}></ViolationTables>
                            </div>

                        </CardBody>
                    </Card>
</Col> 
<Col lg="5">

{/*<Heatmapcontainer center={{ lat: 75.73, lng:-120.39636499999997 }}  CampusID={selectedCampusval} />*/}


</Col>
            </Row>
    </React.Fragment>
  )
}

export default connect(null, { setBreadcrumbItems })(Dashboard);